import React, {Component} from 'react'
import { Row, Col, Card, CardBody, Pagination, PaginationItem, PaginationLink} from 'reactstrap'
import SalesList from '../components/SalesList'
import { withTranslation } from 'react-i18next'


class Sales extends Component{

	constructor(props){
    super(props);

    this.state = {
        customerLayout : "Sales List"
        }
    }

    inventoryList = (props) =>{
    	return(
    		<Card className="card-box">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="title">{this.props.t('Sales Report')}</div>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <SalesList handleOrderView={this.updateLayout}/>
                </CardBody>
            </Card>
            )
    }

    

    updateLayout = (layout) =>{
        this.setState({customerLayout : layout});
    }

    getCustomerComponent(layout){

        var showLayout = '';

        switch(layout){
            case "Sales List" : showLayout=this.inventoryList(this.props);
            break;
            default:
            showLayout = "";
        }

        return showLayout;

    }

	render(){
		let showLayout = this.getCustomerComponent(this.state.customerLayout)
		return(
			<div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        {showLayout}
                    </div>
                </div>
            </div>
			)
	}
}

export default withTranslation()(Sales);